/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderReceiveAddressVo } from './OrderReceiveAddressVo';
import {
    OrderReceiveAddressVoFromJSON,
    OrderReceiveAddressVoFromJSONTyped,
    OrderReceiveAddressVoToJSON,
    OrderReceiveAddressVoToJSONTyped,
} from './OrderReceiveAddressVo';
import type { KoreaReturnOrderCreateItemVo } from './KoreaReturnOrderCreateItemVo';
import {
    KoreaReturnOrderCreateItemVoFromJSON,
    KoreaReturnOrderCreateItemVoFromJSONTyped,
    KoreaReturnOrderCreateItemVoToJSON,
    KoreaReturnOrderCreateItemVoToJSONTyped,
} from './KoreaReturnOrderCreateItemVo';

/**
 * 
 * @export
 * @interface KoreaReturnOrderCreateReqVo
 */
export interface KoreaReturnOrderCreateReqVo {
    /**
     * 本次保存UUID，失败重试沿用原值
     * @type {string}
     * @memberof KoreaReturnOrderCreateReqVo
     */
    requestId?: string;
    /**
     * 来源订单ID
     * @type {number}
     * @memberof KoreaReturnOrderCreateReqVo
     */
    sourceOrderId?: number;
    /**
     * 返送处理方式，沿用RocketReturnProcessMethodEnum
     * @type {number}
     * @memberof KoreaReturnOrderCreateReqVo
     */
    processMethod?: number;
    /**
     * 
     * @type {OrderReceiveAddressVo}
     * @memberof KoreaReturnOrderCreateReqVo
     */
    receiveAddress?: OrderReceiveAddressVo;
    /**
     * 本次返送的合包和独立单品，合包只提交父商品
     * @type {Array<KoreaReturnOrderCreateItemVo>}
     * @memberof KoreaReturnOrderCreateReqVo
     */
    items?: Array<KoreaReturnOrderCreateItemVo>;
}

/**
 * Check if a given object implements the KoreaReturnOrderCreateReqVo interface.
 */
export function instanceOfKoreaReturnOrderCreateReqVo(value: object): value is KoreaReturnOrderCreateReqVo {
    return true;
}

export function KoreaReturnOrderCreateReqVoFromJSON(json: any): KoreaReturnOrderCreateReqVo {
    return KoreaReturnOrderCreateReqVoFromJSONTyped(json, false);
}

export function KoreaReturnOrderCreateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KoreaReturnOrderCreateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'requestId': json['requestId'] == null ? undefined : json['requestId'],
        'sourceOrderId': json['sourceOrderId'] == null ? undefined : json['sourceOrderId'],
        'processMethod': json['processMethod'] == null ? undefined : json['processMethod'],
        'receiveAddress': json['receiveAddress'] == null ? undefined : OrderReceiveAddressVoFromJSON(json['receiveAddress']),
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(KoreaReturnOrderCreateItemVoFromJSON)),
    };
}

export function KoreaReturnOrderCreateReqVoToJSON(json: any): KoreaReturnOrderCreateReqVo {
    return KoreaReturnOrderCreateReqVoToJSONTyped(json, false);
}

export function KoreaReturnOrderCreateReqVoToJSONTyped(value?: KoreaReturnOrderCreateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requestId': value['requestId'],
        'sourceOrderId': value['sourceOrderId'],
        'processMethod': value['processMethod'],
        'receiveAddress': OrderReceiveAddressVoToJSON(value['receiveAddress']),
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(KoreaReturnOrderCreateItemVoToJSON)),
    };
}

